import React, { useState, useEffect } from 'react'
import CardLayout from '../../../components/utils/CardLayout'
import SearchBar from '../../../components/utils/SearchBar'
import Table from '../../../components/utils/Table'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import Button from '../../../components/utils/Button'
import NetworkActions from '../../../redux/network/actions'
import InventoryActions from "../../../redux/PortinInventory/actions"
import { convertDateToRequiredFormatTZ } from '../../../helpers/commonFunction';
import Tag from '../../../components/utils/Tag'
import DownloadCloud2sLineIcon from 'remixicon-react/DownloadCloud2LineIcon';
import * as XLSX from 'xlsx';
import FileSaver from 'file-saver';
import Styles from './portinSimlist.module.css'
import shortCodeAction from '../../../redux/shortCodeData/actions';

const { getActiveNetwork } = NetworkActions
const { getPortinSimList } = InventoryActions;
const { getShortCode } = shortCodeAction;

const PortinSimList = () => {
    const dispatch = useDispatch();
    const [networkId, setNetworkId] = useState(0);
    const [filterText, setFilterText] = useState("");
    const { networkResult } = useSelector((state) => state.network);
    const { shortCodeResult } = useSelector((state) => state.shortCode);
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const { portinSimList, portinSimListLoading, buttonLoading } = useSelector((state) => state.portinInventory);
    const [searchData, setSearchData] = useState({
        networkID: '',
        serialNumber: '',
        statusID: ''
    });
    const [statusData, setstatusData] = useState({
        tableName: "sim",
        fieldName: "Status"
    });
    const [searched, setSearched] = useState(false);
    const { register, handleSubmit, formState: { errors }, setError, clearErrors, reset } = useForm({ defaultValues: searchData });

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'SERIAL NUMBER', key: 'serialNumber' },
        { displayName: 'NETWORK', key: 'network' },
        { displayName: 'DATE', key: 'date' },
        { displayName: 'STATUS', key: 'status' },
    ];

    useEffect(() => {
        dispatch(getActiveNetwork());
        // dispatch(getPortinSimList(searchData));
        dispatch(getShortCode(statusData));
    }, []);

    // useEffect(() => {
    //     const filteredNetworks = networkResult?.filter(network => network.ID == 9);
    //     if (filteredNetworks.length === 1) {
    //         const singleNetworkID = filteredNetworks[0].ID;
    //         setNetworkId(singleNetworkID);
    //         reset({
    //             ...searchData,
    //             networkID: singleNetworkID
    //         });
    //     }
    // }, [networkResult]);


    const handleSearch = (data) => {
        setSearched(true);
        dispatch(getPortinSimList(data));
    };

    const handleNetwork = (e) => {
        e.preventDefault();
        setNetworkId(e.target.value);
    }
    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const filteredItems = Array.isArray(portinSimList) ? portinSimList.filter(item =>
        Object.values(item).some(value =>
            typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase())
        )
    ) : [];

    const dataSource = filteredItems.map((item, key) => ({
        key: key + 1,
        serialNumber: item.SerialNumber,
        network: item.NetworkName,
        status: <Tag color={`${item.StatusValue === "Free" ? "badge-success" : item.StatusValue === "Under Processing" ? "badge-warning" : item.StatusValue === "Used" ? "badge-secondary" : item.StatusValue === "Active" ? "badge-secondary" : "badge-danger"
            }`} title={item.StatusValue} />,
        date: convertDateToRequiredFormatTZ(item.CreatedDtTm),
    }));

    const listData = filteredItems.map((item, key) => ({
        'Sr. No': key + 1,
        'Serial Number': item.SerialNumber,
        'Network': item.NetworkName,
        'Status': item.StatusValue,
        'Date': convertDateToRequiredFormatTZ(item.CreatedDtTm),
    }));

    const exportToCSV = async () => {
        if (listData && listData.length > 0) {
            const ws = XLSX.utils.json_to_sheet(listData);
            const wb = { Sheets: { 'portinSimList': ws }, SheetNames: ['portinSimList'] };
            const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: fileType });
            await FileSaver.saveAs(data, 'Portin_Sim_List' + fileExtension);
        }
    }

    const renderManualActivationTable = () => {
        if (searched) {
            return (
                <Table columns={columns} data={dataSource} loading={portinSimListLoading} pagination={true} />
            );
        } else {
            return null;
        };
    }


    return (
        <CardLayout title="Portin SIM List">
            <form onSubmit={handleSubmit(handleSearch)}>

                <div className="row">
                    <div className="col-md-3 mb-3">
                        <label className='ml-2'> Network <span className='text-danger'></span></label>
                        <select className="form-control" placeholder="Select Network" name="networkID"  {...register("networkID", {
                        })} onChange={(e) => { handleNetwork(e) }} >
                            <option value="" key="0">Select</option>
                            {networkResult.filter(network => network.ID == 9 || network.ID == 10).map(network => (
                                <option name="network" value={network.ID} key={network.ID}>{network.NetworkName}</option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-3 mb-3">
                        <label>Select Status</label>
                        <select className="form-control" id="statusID" name="statusID" {...register("statusID")} >
                            <option value="" name="All">All</option>
                            {shortCodeResult && shortCodeResult.length > 0 && shortCodeResult.filter(item => item.ID !== 5).map((item, ind) => (
                                <option key={item.ID} value={item.ID}> {item.Value} </option>
                            ))}
                        </select>
                    </div>

                    <div className="col-md-3 mb-3">
                        <label>Serial Number</label>
                        <input type="text" className="form-control" id="serialNumber" name="serialNumber" placeholder="Serial Number" {...register("serialNumber", {
                        })}></input>
                    </div>

                    <div className="col-lg-2 mb-2 col-md-4" >
                        <div className="mb-2 mt-lg-4 mt-md-4">
                            <Button title="Search" style="minWidth:80px" loading={buttonLoading} buttonClass={` btn btn-primary mt-1 btn-md Activity_searchBtn__GlBtC`} buttonType='submit' />
                        </div>
                    </div>
                </div>
            </form>
            {searched ?
                <div className='d-flex justify-content-between mt-3'>
                    <SearchBar onFilter={handleFilterChange} filterText={filterText} />
                    <div className='audit-report-Export-btn'><Button icon={<DownloadCloud2sLineIcon color='#fff' className='mr-1 excel-btn-1-aidit ' size={'0.9rem'} />} title="Export" buttonClass={`btn ${Styles.exportBtn}`} style={{ marginRight: "10px" }} buttonStyle="primary" onClick={exportToCSV} /></div>
                </div> : ""}
            {renderManualActivationTable()}
        </CardLayout>
    )
}

export default PortinSimList
